import styled from 'styled-components';

export const Wrap = styled.div`
	width: 100%;
	.react-loading-skeleton {
		margin-bottom: 0.5rem;
	}
`;
